import http from './http';
import { listResource } from './listResource';

export async function listRegions(options = {}) {
  return listResource('/regions', options);
}

/**
 * Obtiene un región por su ID.
 */
export async function getRegionById(id) {
  const res = await http.get(`/regions/${id}`);
  return res.data?.data ?? res.data;
}

export async function getRegionStatesForDownload(id) {
  const res = await http.get(`/regions/${id}/states-for-download`);
  return res.data?.data ?? res.data;
}

/**
 * Obtiene la lista de roles.
 */
export async function listStates() {
  const res = await http.get('/states/available');
  return res.data?.data ?? res.data ?? [];
}

/**
 * Obtiene la lista de módulos.
 */
export async function listModules() {
  const res = await http.get('/modules');
  return res.data?.data ?? res.data ?? [];
}

/**
 * Obtiene la lista de notifiaciones disponibles.
 */
export async function listregionsOptions() {
  const res = await http.get('/Region-settings');
  return res.data?.data ?? res.data ?? [];
}

/**
 * Actualiza un región.
 */
export async function updateRegion(id, userData) {
  const res = await http.put(`/regions/${id}`, userData);
  return res.data?.data ?? res.data;
}

/**
 * Crear un región.
 */
export async function createRegion(userData) {
  const res = await http.post(`/regions/`, userData);
  return res.data?.data ?? res.data;
}

/**
 * Activar/Desactivar región
 */
export const updateRegionStatus = (id, isActive) =>
  // eslint-disable-next-line camelcase
  http.patch(`/regions/status/${id}`, { is_active: isActive });

/**
 * Eliminar región
 */
export const deleteRegion = (id) => http.delete(`/regions/${id}`);

export async function addRegionState(id, stateId) {
  const res = await http.patch(`/regions/${id}/states`, { state_id: stateId, });
  return res.data?.data ?? res.data;
}

/**
 * Eliminar estado de una región
 */
export async function deleteRegionState(id, stateId) {
  const res = await http.delete(`/regions/${id}/states/${stateId}`);
  return res.data?.data ?? res.data;
}

/**
 * Revisar que no este en uso la región.
 */
export async function checkRegionExists(title, excludeId = null) {
  try {
    const { items } = await listRegions({ search: title });
    const exists = items?.some(
      (item) =>
        item.description?.toLowerCase() === title?.toLowerCase() &&
        item.id !== Number(excludeId)
    );
    return exists;
  } catch (error) {
    console.error('Error al verificar la región:', error);
    return false;
  }
}